import PropTypes from 'prop-types';
import React from 'react'


export default class extends React.Component {
    static propTypes = {
		input_name: PropTypes.string.isRequired,
		value: PropTypes.string.isRequired,
		selected_now: PropTypes.string.isRequired,
		selected_goal: PropTypes.string,
		nowOrGoal: PropTypes.oneOf(['now','goal']).isRequired,
		changeData: PropTypes.func.isRequired,
	};

    changeData = (field, e) => {
		return this.props.changeData(this.props.value);
	};

    render() {
	
		var id = this.props.input_name + '_' + this.props.value,
			selectedNow = this.props.selected_now == this.props.value && this.props.nowOrGoal === 'now' ? 'selected-now' : '',
			selectedGoal = this.props.selected_goal == this.props.value && this.props.nowOrGoal === 'goal' ? ' selected-goal' : '';

		return (
			<p htmlFor={id} className={ selectedNow + selectedGoal + ' clickable'} onClick={this.changeData}>
				<span onClick={this.pulseText}>{this.props.text}</span>
			</p>
		)

	}
}



// WEBPACK FOOTER //
// ./src/js/views/Registration/RegistrationParts/TemplateParts/SelectionItem.jsx